import TimePicker, { type TimePickerFieldProps } from '../../components/TimePickerField';
import ClockIcon from '../../icons/mobility/clock.svg';
import { RangePickerContainer } from './Fields/shared';

const TimePickerField = ({ disabled, ...props }: TimePickerFieldProps) => (
    <RangePickerContainer disabled={Array.isArray(disabled) ? disabled.some(Boolean) : disabled}>
        <TimePicker {...props} disabled={disabled} suffixIcon={<ClockIcon />} />
    </RangePickerContainer>
);

export default TimePickerField;
